import http from '../auth/httpService';

export function getCopyright() {
  return http.get('/copyright');
}